import i18n from '@/plugins/vuei18n'

export default {
  FORM: 1,
  TEST: 2,
  DOCUMENT: 3,

  schemaType : [
     { name: i18n.t('base.form'), value: 1},
     { name: i18n.t('base.test'), value: 2 },
     { name: i18n.t('base.document'), value: 3 }
  ]
}
